import TextInput from '@/components/common/TextInput';
import React from 'react';
import { FormGroupProps } from './types';

type Props = FormGroupProps & {
  labelTitle: string;
  handleAlbumField: (field: string, value: string) => void;
};

export default function TitleFormGroup({
  album,
  readonly,
  disabled,
  labelTitle,
  showValidationErrors,
  fieldHasErrors,
  findErrorMessage,
  handleAlbumField,
}: Props) {
  return (
    <div className="form-group">
      <TextInput
        labelClassName="col-sm-3 form-label"
        labelTitle={labelTitle}
        handleInput={(e) => {
          handleAlbumField('title', e.target.value);
        }}
        id="title"
        type="text"
        value={album.title}
        inputClassname="form-control"
        className="col-sm-6"
        isReadOnly={readonly}
        isDisabled={disabled}
        hasErrors={fieldHasErrors('Title')}
        errorMessage={findErrorMessage('Title')}
        autoFocus={true}
        isRequired={true}
        showValidationErrors={showValidationErrors}
        fieldValidationKey={'productEditMode.Title'}
      />
    </div>
  );
}
